import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateSignature from '@/shared/http/repositories/business/qmaTemplateSignature'
import qmaTemplateHeader from '@/shared/http/repositories/business/qmaTemplateHeader'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'templateTable',
  mixins: [ActionsForm],
  props: ['tipoFluxo', 'tipo'],
  components: {},
  data () {
    return {
      colum: ['DESCRIÇÃO ', 'DATA DE CRIAÇÃO', 'ÚLTIMA ATUALIZAÇÃO', ''],
      dados: [],
      formSearch: {},
      categoria: null,
      edicao: false,
      id: null,
      novoItemDescricao: null,
      item: null,
      statusCabecalho: null,
      novoItemTipo: null,
      // 2026-05-28: trava de exclusao de item em uso - lista de templates pro modal V3 (com botao "Remover deste template" por linha)
      templatesEmUso: []
    }
  },

  mounted () {
    this.onLoadTable(this.tipo)
  },
  methods: {
    onLoadTable (tipo) {
      loading.push()
      this.categoria = tipo
      this.formSearch.TipoFluxo = this.tipoFluxo === 'PIVS' ? 2 : this.tipoFluxo === 'PIT' ? 1 : 0
      if (this.categoria === 0) {
        qmaTemplateSignature.GetItensAssinaturaCadastroBasico(this.$refs.tableGridsCadastroBasicoPivs.pagingLimit, this.$refs.tableGridsCadastroBasicoPivs.pagingIndex, {TipoFluxo: this.formSearch.TipoFluxo, Descricao: this.formSearch.Descricao, DataInclusaoInicio: this.formSearch.DataInclusaoInicio, DataInclusaoFim: this.formSearch.DataInclusaoFim})
          .then((Response) => {
            loading.pop()
            this.$refs.tableGridsCadastroBasicoPivs.LoadAllByData(Response)
            this.dados = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      } else if (this.categoria === 1) {
        qmaTemplateHeader.GetItenCabecalhoCadastroBasico(this.$refs.tableGridsCadastroBasicoPivs.pagingLimit, this.$refs.tableGridsCadastroBasicoPivs.pagingIndex, {TipoFluxo: this.formSearch.TipoFluxo, Descricao: this.formSearch.Descricao, DataInclusaoInicio: this.formSearch.DataInclusaoInicio, DataInclusaoFim: this.formSearch.DataInclusaoFim})
          .then((Response) => {
            loading.pop()
            this.$refs.tableGridsCadastroBasicoPivs.LoadAllByData(Response)
            this.itenscabecalho()
            this.dados = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    },
    itenscabecalho () {
      loading.push()
      qmaTemplateHeader.GetStatusTipoCabecalho()
        .then((Response) => {
          loading.pop()
          this.statusCabecalho = Response.data
        })
    },
    salvarNovoItemCabecalho () {
      if (this.novoItemDescricao === null && this.novoItemTipo === null) {
        return toast.warning('Preencha os campos de Descrição e Tipo do Campo')
      }
      qmaTemplateHeader.PostNovoItemCabecalho({descricao: this.novoItemDescricao, tipo: this.novoItemTipo})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.novoItemTipo = null
          this.onLoadTable(this.categoria)
          this.fechaPopAddEdicao()
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    salvarEdicaoItemCabecalho () {
      if (this.novoItemDescricao === null && this.novoItemTipo === null) {
        return toast.warning('Preencha os campos de Descrição e Tipo do Campo')
      }
      qmaTemplateHeader.PostEdicaoItemCabecalho({descricao: this.novoItemDescricao, tipo: this.novoItemTipo, id: this.id})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.novoItemTipo = null
          this.onLoadTable(this.categoria)
          this.fechaPopAddEdicao()
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    exclusaoItemCabecalho () {
      if (this.id === null) {
        return toast.warning('O item não foi localizado')
      }
      qmaTemplateHeader.ExclusaoItemCabecalho({id: this.id})
        .then((Response) => {
          loading.pop()
          this.onLoadTable(this.categoria)
          this.fechaPopExclusao()
          toast.success('Sucesso na Exclusão')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          // 2026-05-28: trava de exclusao - 409 traz lista de templates em uso pro modal V3
          if (Error.response && Error.response.status === 409 && Error.response.data && Error.response.data.junctions) {
            this.$refs['exclusao'].hide() // hide sem zerar this.id, pra re-tentar exclusao quando lista esvaziar
            this.abreModalEmUso(Error.response.data.junctions)
          } else {
            toast.warning(Error.response.data)
          }
        })
    },
    salvarNovoItemAssinatura () {
      if (this.novoItemDescricao === null) {
        return toast.warning('Preencha os campos de Descrição')
      }
      qmaTemplateSignature.PostNovoItemAssinatura({descricao: this.novoItemDescricao, fluxo: this.tipoFluxo})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.onLoadTable(this.categoria)
          this.fechaPopAddEdicao()
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    salvarEdicaoItemAssinatura () {
      if (this.novoItemDescricao === null) {
        return toast.warning('Preencha o campo de Descrição')
      }
      qmaTemplateSignature.PostEdicaoItemAssinatura({descricao: this.novoItemDescricao, fluxo: this.tipoFluxo, id: this.id})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.onLoadTable(this.categoria)
          this.fechaPopAddEdicao()
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    exclusaoItemAssinatura () {
      if (this.id === null) {
        return toast.warning('O item não foi localizado')
      }
      qmaTemplateSignature.PostExclusaoItemAssinatura({id: this.id})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.onLoadTable(this.categoria)
          this.fechaPopExclusao()
          toast.success('Sucesso na Exclusão')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          // 2026-05-28: trava de exclusao - 409 traz lista de templates em uso pro modal V3
          if (Error.response && Error.response.status === 409 && Error.response.data && Error.response.data.junctions) {
            this.$refs['exclusao'].hide() // hide sem zerar this.id, pra re-tentar exclusao quando lista esvaziar
            this.abreModalEmUso(Error.response.data.junctions)
          } else {
            toast.warning(Error.response.data)
          }
        })
    },
    popUpAdd (value) {
      this.edicao = false
      this.novoItemDescricao = null
      this.novoItemTipo = null
      this.$refs['add-cadastro'].show()
    },
    popUpEdicao (value) {
      this.edicao = true
      this.id = value.id
      this.novoItemDescricao = value.descricao
      if (this.categoria === 1) {
        this.novoItemTipo = value.tipoCampo
      }
      this.$refs['add-cadastro'].show()
    },
    fechaPopAddEdicao (value) {
      this.$refs['add-cadastro'].hide()
    },
    popUpExclusao (value) {
      this.id = value.id
      this.item = value.descricao
      this.$refs['exclusao'].show()
    },
    fechaPopExclusao (value) {
      this.id = null
      this.$refs['exclusao'].hide()
    },
    // 2026-05-28: trava de exclusao - modal V3 com lista de templates em uso + acao "Remover deste template" por linha
    abreModalEmUso (junctions) {
      this.templatesEmUso = junctions
      this.$refs['modalEmUso'].show()
    },
    fechaModalEmUso () {
      this.$refs['modalEmUso'].hide()
      this.templatesEmUso = []
      this.id = null
    },
    removerDoTemplate (juncaoId) {
      loading.push()
      const isCabecalho = this.categoria === 1
      const api = isCabecalho
        ? qmaTemplateHeader.InativarJuncaoCabecalho(juncaoId)
        : qmaTemplateSignature.InativarJuncaoAssinatura(juncaoId)
      api
        .then(() => {
          loading.pop()
          this.templatesEmUso = this.templatesEmUso.filter(t => t.juncaoId !== juncaoId)
          if (this.templatesEmUso.length === 0) {
            // ultima juncao removida -> re-tenta a exclusao do item (this.id ainda esta setado)
            this.$refs['modalEmUso'].hide()
            toast.success('Item liberado para exclusão')
            if (isCabecalho) {
              this.exclusaoItemCabecalho()
            } else {
              this.exclusaoItemAssinatura()
            }
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/registerbasicQMA/components/tableQma/tableQma.js